export default __webpack_public_path__ + "static/media/volume-filled.cffb80f2.svg";